import TableV1 from "../../../../components/form_builder/elements/table/TableV1.vue";

export default {
  componentName: "fb-table-v1",
  component: TableV1,
  defaultAttrs: {
    properties: {
      columns: [
        {
          key: "column1",
          label: "Column 1"
        },
        {
          key: "column2",
          label: "Column 2"
        },
        {
          key: "column3",
          label: "Column 3"
        }
      ],
      items: [
        {
          column1: "Column 1 Value",
          column2: "Column 2 Value",
          column3: "Column 3 Value"
        }
      ],
      style: {},
      hidden: false,
      dependentProperties: {}
    }
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value
  },
  validate: () => {
    return [];
  }
};
